/**
 * Graph pop-over for the client-rendered leaf pages (individuals, tracts,
 * blocks, precincts, voters): once a detail page has rendered, it queues its
 * graph target and loads /js/entity-graph.js, which registers the real Graph
 * control in place of the placeholder (graph-control.ts; the identity bar
 * replaces a control with the same id).
 */
import type { GraphTarget } from './entity-graph-types';

const LOADER_SRC = '/js/entity-graph.js';

export function registerGraphTarget(target: GraphTarget): void {
  const queue = (window.electinfoGraphTargets = window.electinfoGraphTargets || []) as { push: (...t: GraphTarget[]) => void };
  queue.push(target);
  if (document.querySelector(`script[src*="${LOADER_SRC}"]`)) return;
  const script = document.createElement('script');
  script.src = LOADER_SRC;
  script.defer = true;
  document.head.appendChild(script);
}
